import { ScrollView } from '@rbilabs/universal-components';

export const Wrapper = ScrollView;
